import { render, staticRenderFns } from "./CustomerLocationCard.vue?vue&type=template&id=1cf4a614"
import script from "./CustomerLocationCard.vue?vue&type=script&lang=js"
export * from "./CustomerLocationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports